
<template>
  <div>
    <v-card flat width="100%">
      <v-card-title class="red white--text d-flex rounded-0 flex-wrap">
        <div class="d-flex">
          <v-sheet v-if="selected" :width="$vuetify.breakpoint.smAndUp ? '200px' : ''" class="d-flex align-center  transparent">
            <v-btn @click="resetModule()" icon class="white error--text" >
              <v-icon>mdi-arrow-left-thick</v-icon>
            </v-btn>
          </v-sheet>
          <change-systems text v-if="!selected || done_order.show"></change-systems>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex flex-column justify-center text-center">
          <h2>{{module_title}}</h2>
          <small>{{module_subtitle}}</small>
        </div>
        <v-spacer></v-spacer>
        <v-sheet width="200px" class="d-flex align-center justify-end transparent">
          <v-avatar class="white" v-if="$vuetify.breakpoint.mdAndUp">
            <v-icon class="error--text">mdi-note-plus</v-icon>
          </v-avatar>
        </v-sheet>
      </v-card-title>
      <v-card-text class="pa-0 ma-0">
        <v-container>
          <div v-if="!selected && !done_order.show" class="mt-4">
            <span class="text-h5">Qual a origem da carga ?</span>
            <v-btn block color="#E53935" class="mb-5 mt-10" @click="setWholesale()" dark> 
              <v-icon left>mdi-store-settings</v-icon>Fábrica (Grandes cargas)
            </v-btn>
            <v-btn block color="#E53935" class="mt-5 mb-10" @click="setRetail()" dark> 
              <v-icon left>mdi-cart</v-icon> Galpão
            </v-btn>
          </div>
          <template v-if="!selected && done_order.show">
            <OrderFinished :done_order="done_order" @newOrder="handleNewOrder()"></OrderFinished>
          </template>
          <template v-if="selected  && wholesale && !loading">
            <CreateWholesaleOrder @created="handleCreated"></CreateWholesaleOrder>
          </template>
          <template v-if="selected && retail && !loading">
            <CreateRetailOrder @created="handleCreated"></CreateRetailOrder>
          </template>
          <template v-if="loading">
            <v-sheet height="40vh" class="d-flex justify-center align-center">
              <div class="d-flex flex-column align-center title">
                <span class="mb-2">Carregando...</span>
                <v-progress-circular  indeterminate color="blue-grey darken-1" size="50"></v-progress-circular>
              </div>
            </v-sheet>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'CreateOrder',
  components: {
    CreateCard: () => import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    SelectDepot: () => import("@/_backoffice/_registrations/components/shared/SelectDepot.vue"),
    CreateWholesaleOrder: () => import("@/components/create_order/wholesale_components/CreateWholesaleOrder.vue"),
    CreateRetailOrder: () => import("@/components/create_order/retail_components/CreateRetailOrder.vue"),
    OrderFinished: () => import("@/components/create_order/OrderFinished.vue"),
    ChangeSystems: () => import("@/components/shared/ChangeSystems.vue"),
  },
  data() {
    return {
      selected: false,
      loading: false,
      retail: false,
      wholesale: false,
      done_order: {
        show: false,
        id: null,
        solution: null,
      }
    }
  },
  computed:{
    isMobile(){
      return this.$vuetify.breakpoint.mdAndDown
    },
    module_title(){
      if(this.done_order.show){
        return 'Pedido Finalizado'
      }else{
        return 'Cadastrar Pedido'
      }
    },
    module_subtitle(){
      if(this.wholesale){
        return 'Grandes Cargas'
      }else if(this.retail){
        return 'Galpão'
      }else{
        return ''
      }
    },
  },
  methods: {
    handleNewOrder(){
      this.resetModule()
    },
    handleCreated(order){
      this.resetModule()
      this.done_order.show = true
      this.done_order.id = order.id
      this.done_order.solution = order.solution
    },
    setLoading(){
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 1000);
    },
    setWholesale(){
      this.wholesale = true
      this.selected = true
      this.setLoading()
    },
    setRetail(){
      this.retail = true
      this.selected = true
      this.setLoading()
    },
    resetModule(){
      this.retail = false
      this.wholesale = false
      this.selected = false
      this.done_order.show = false
    }
  },
}
</script>